// deps
import styled from "styled-components";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

const SMILEY_DIMENSION = "28px";

export const ImageContainer = styled.span`
    position: relative;
    top: 5px;
    display: inline-block;
`;

export const SmileyImage = styled(Image)(({ theme }) => ({
    width: SMILEY_DIMENSION,
    height: SMILEY_DIMENSION,
    marginLeft: theme.spacing.xxSmall,
}));
